export enum UserSubscriptionRequestStatusEnum {
  TO_REVIEW = "TO REVIEW",
  REJECT = "REJECT",
  FINAL_REJECT = "FINAL REJECT",
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  TO_PAY = "TO PAY",
  ARCHIVED = 'ARCHIVED',
  DONE = 'DONE',
}